module.exports = __webpack_public_path__ + "d9e87407cea5389673591de4d26d814e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Coinstack.png
// module id = 1427
// module chunks = 0